import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-tracker-graph',
  templateUrl: './tracker-graph.component.html',
  styleUrls: ['./tracker-graph.component.scss']
})
export class TrackerGraphComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
